import { render, staticRenderFns } from "./GifSelectorModal.vue?vue&type=template&id=32f54c04"
import script from "./GifSelectorModal.vue?vue&type=script&lang=js"
export * from "./GifSelectorModal.vue?vue&type=script&lang=js"
import style0 from "./GifSelectorModal.vue?vue&type=style&index=0&id=32f54c04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/skade-pwa/components/ui/atom/Img.vue').default,Spinner: require('/skade-pwa/components/ui/atom/Spinner.vue').default,Modal: require('/skade-pwa/components/ui/atom/Modal.vue').default})
